export enum HorsesEvents {
    userUpdatedHorse = 'user_updated_horse',
    userCreatedHorse = 'user_created_horse',
    userAddedContactToHorse = 'user_added_contact_to_horse',
    userDeletedHorse = 'user_deleted_horse',
    userUsedHorsesSearchBar = 'user_used_horses_search_bar',
    userAddedHorseBreed = 'user_added_horse_breed',
    userAddedHorseWorkType = 'user_added_horse_work_type',
    userAddedHorseGender = 'user_added_horse_gender',
    userAddedHorseAge = 'user_added_horse_age',
    userAddedHorseShoeCycle = 'user_added_horse_shoe_cycle',
    horseLocationPromptShown = 'horse_location_prompt_shown',
    horseLocationPromptSkipped = 'horse_location_prompt_skipped',
    horseLocationFlowStarted = 'horse_location_flow_started',
    horseLocationSaved = 'horse_location_saved',
    horseLocationNamed = 'horse_location_named',
    horseLocationNameCancelled = 'horse_location_name_cancelled',
}

export type HorseLocationSource =
    | 'horse_form'
    | 'horse_profile'
    | 'entry_form'
    | 'entry_detail'
    | 'horses_list';
